import { Icon, theme, StyledButton } from '../component-library';
import { useMediaQuery } from '../helpers/useMediaQuery';

const ResponsiveButton = ({ children, ...props }) => {
  const smallScreen = useMediaQuery('(max-width: 850px)');
  return (
    <StyledButton
      uppercase
      fontSize={smallScreen ? '0.75rem' : '0.875rem'}
      style={{ cursor: props.disabled ? 'not-allowed' : 'pointer' }}
      fontFamily='Plus Jakarta Sans'
      fontWeight={800}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

const DefaultButton = ({ text, type, icon, ...props }) => {
  const renderButton = () => {
    switch (type) {
      case 'correct':
        return (
          <ResponsiveButton bg={theme.colors.lightGreen} color={theme.colors.darkGrey} border={`1px solid ${theme.colors.darkGrey}`} {...props}>
            {text}
          </ResponsiveButton>
        );
      case 'incorrect':
        return (
          <ResponsiveButton bg={theme.colors.negativeLight} color={theme.colors.darkGrey} border={`1px solid ${theme.colors.darkGrey}`} {...props}>
            {text}
          </ResponsiveButton>
        );
      case 'repeat':
        return (
          <ResponsiveButton bg={theme.colors.lightGrey} color={theme.colors.darkGrey} border={`1px solid ${theme.colors.darkGrey}`} {...props}>
            {text}
          </ResponsiveButton>
        );
      case 'end-test':
        return (
          <ResponsiveButton bg={theme.colors.negativeDark} color={'#fff'} {...props}>
            {text}
          </ResponsiveButton>
        );
      case 'grey':
        return (
          <ResponsiveButton bg={theme.colors.silver} color='black' mb='10px' {...props}>
            {text}
          </ResponsiveButton>
        );
      case 'transparent':
        return (
          <ResponsiveButton bg='transparent' mb='10px' {...props}>
            {text}
          </ResponsiveButton>
        );
      case 'icon':
        return (
          <ResponsiveButton {...props}>
            <Icon icon={icon} size={20} color='white' mr='15px' />
            {text}
          </ResponsiveButton>
        );
      default:
        return (
          <ResponsiveButton {...props} bg={theme.colors.primary}>
            {text}
          </ResponsiveButton>
        );
    }
  };

  return <>{renderButton()}</>;
};

export default DefaultButton;
